<ng-container *ngIf="isLoading; else pageContent">
  <div class="app-spinner">
    <mat-spinner></mat-spinner>
  </div>
</ng-container>
 
<ng-template #pageContent>
  <div class="container-fluid">
    <div class="row">
      <div class="header-row sticky-header">
        <div class="text-start ms-3"><span>Notifications</span></div>
        <div class="text-end">
          <span (click)="close()">
            <img src="assets/images/close_button.svg" alt="cancel" />
          </span>
        </div>
      </div>
 
      <div class="all-row mb-3 ms-3">
        <span class="all-text">{{ source === 'notifications' ? 'All' : 'Recent'}}</span>
        <span class="count-badge" (click)="markAllNotificationsAsRead()">{{ totalNotificationCount}}</span>
      </div>
	<ng-container *ngIf="teacherNotifications.length > 0; else noNotifications">
      <div class="notifications-scrollable">
        <div
          *ngFor="let notification of teacherNotifications"
          class="notification-card mb-3"
          [ngClass]="{ unread: !notification.is_read, read: notification.is_read}">
			
          <div class="icon-box ms-2">
            <span *ngIf="!notification.is_read" class="unread-dot"></span>
            <mat-icon *ngIf="notification.notification_type === notificationTypeEnum.CLASSROOM_JOIN">school</mat-icon>
           <mat-icon  *ngIf="notification.notification_type === notificationTypeEnum.QUIZ_ATTEMPT">assignment</mat-icon>
           <mat-icon  *ngIf="notification.notification_type === notificationTypeEnum.AI_COURSE">menu_book</mat-icon>   
		     <mat-icon *ngIf="notification.notification_type === notificationTypeEnum.AI_COURSE_FAILED">error</mat-icon>
          </div>
 
          <div class="content-box">
            <div class="title">

			<span *ngIf="notification.notification_type === notificationTypeEnum.CLASSROOM_JOIN">
			    {{notification.student_name || 'A'}} 
				<p class="subtitle">joined your classroom</p>
			</span>
			
				<span *ngIf="notification.notification_type === notificationTypeEnum.QUIZ_ATTEMPT">
					{{notification.student_name || 'B'}}
				<p class="subtitle">attempted the quiz </p>
               </span>

			   <span *ngIf="notification.notification_type === notificationTypeEnum.AI_COURSE">
				<p class="subtitle">
					Your requested course
					<span class="subtitle-color">{{notification.course_name}}</span>
					 has been successfully generated. Tap to review the full content.
				</p>
		 
               </span>

			   <span *ngIf="notification.notification_type === notificationTypeEnum.AI_COURSE_FAILED">
				<p class="subtitle">There was an issue generating your course 
				{{notification.course_name}}. Please try again.</p>	
				</span>

			</div>  

			<button
              class="btn-add p-2"
              *ngIf="notification.notification_type === notificationTypeEnum.CLASSROOM_JOIN"
              (click)="goToClassroomPage(notification.classroom_id)">
              View Classroom
            </button>
 
 
            <button
              class="btn-add p-2"
              *ngIf="notification.notification_type === notificationTypeEnum.QUIZ_ATTEMPT"
              (click)="goToQuizPage(notification.classroom_id)">
              View Quiz
            </button> 

			  <button
              class="btn-add p-2"
              *ngIf="notification.notification_type === notificationTypeEnum.AI_COURSE"
              (click)="goToCoursePage(notification.classroom_id)">
              View Course
            </button> 
			
			<button
              class="btn-add p-2"
              *ngIf="notification.notification_type === notificationTypeEnum.AI_COURSE_FAILED"
              (click)="goToCoursePage(notification.classroom_id)">
              View Course
            </button> 

          </div>
 
          <div class="meta-box">
            <span class="time">{{ notification.submitted_at | timeAgo }}
            </span>
			<img
              src="assets/images/delete.svg"
              alt="delete"
              (click)="openDeleteNotificationBox(notification.id)" />
        </div>
      </div>
    </div>
	</ng-container>
  </div>
  </div>
<ng-template #noNotifications>
<div class="no-notifications text-start p-4">
      <p>No notifications found</p>
    </div>
</ng-template>
</ng-template>